var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('p',[_vm._v("Sie haben keine Berechtigung für diesen Bereich")])])
}]

export { render, staticRenderFns }